import ChairLamp from '../../src/legacy/ChairLamp';
export default ChairLamp;
